import { render, staticRenderFns } from "./bizSettlement.vue?vue&type=template&id=9295f7a2&scoped=true&"
import script from "./bizSettlement.vue?vue&type=script&lang=js&"
export * from "./bizSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9295f7a2",
  null
  
)

export default component.exports